import React from 'react';

import { IReferee } from '../../../typings/player';
import { FORMATIONS } from '../../../typings/report-tabs';
import { ITeamTypings } from '../../../typings/team';
import { ITeamHeader } from '../../molecules/team-header/team-header';
import { IMatchFormationField } from '../match-formation-field/match-formation-field';
import { IReportTabsPanel } from '../../molecules/report-tabs-panel/report-tabs-panel';
import IconFormation from '../../atoms/icons/icon-formation';
import CourtesyMessage from '../courtesy-message/courtesy-message';
import t from '../../../labels/labelling-utils';

export const transformerTeam = (team: ITeamTypings): ITeamTypings => {
  const { name, formation, logoUrl } = team;

  return { name, formation, logoUrl };
};

export const getTeamHeader = (team: ITeamTypings, isHome: boolean = true): ITeamHeader => ({
  formation: team.formation!,
  team: transformerTeam(team),
  isHome,
});

export const getMatchFormationField = (team: IMatchFormationField, isHome: boolean = true): IMatchFormationField => {
  const { formation, players, hasImage = false } = team;
  return {
    formation,
    players,
    hasImage,
    isHome,
  };
};

export const getReportTabsPanel = (
  home?: ITeamTypings,
  away?: ITeamTypings,
  referees?: IReferee[]
): IReportTabsPanel => ({
  home,
  away,
  referees,
  panelVariant: FORMATIONS,
  status: 'PreMatch',
});

/**
 * Background Icon for Formation Courtesy Message
 */
const backgroundIconFormation = () => <IconFormation size="xxlarge" color="medium-light" />;

/**
 * Utility function to get Courtesy Messages
 */
export const getCourtesyMessage = () => (
  <CourtesyMessage text={t('match.formation.field.errorMessage')} backgroundIcon={backgroundIconFormation()} />
);
